<template>
    <div class="vacancy-form-wrap">
        <div class="vacancy-form-overflow" @click="closeModaljoin()"></div>
        <form ref="vform" class="form vacancy-form" @submit.prevent="submit" id="wrapper">
            <div class="close-modal icon-cross" @click="closeModaljoin()"></div>

            <div class="wrap">
                <div class="title-wrap">
                    <div class="title">Apply for a job</div>
                </div>

                <fieldsvacancy :items="form" @returnStatusToParent="formStatus =>childIsValid=formStatus"></fieldsvacancy>

                <label for="upload" class="upload-file">
                    <div class="icon"><img src="/images/icons/clip.svg" alt=""></div>
                    <input type="file" @change="onFileChange" value="" id="upload">
                    <span class="button">{{ fileName ? fileName : 'Select CV / resume' }}</span>
                </label>

                <div class="row" v-if="$store.state.submitStatus === 'ERROR' || $store.state.submitStatus === 'OK' || $store.state.submitStatus === 'PENDING'">
                    <div class="col wide">
                        <div class="info-text">
                            <div class="success" v-if="$store.state.submitStatus === 'OK'">
                                <div class="icon-cross close" @click="$store.state.submitStatus = null"></div>
                                Thanks for your submission!
                            </div>
                            <div class="error-wrap" v-if="$store.state.submitStatus === 'ERROR'">
                                <div class="icon-cross close" @click="$store.state.submitStatus = null"></div>
                                Some required fields are missing. Please fix them.
                            </div>
                            <div class="typo__p" v-if="$store.state.submitStatus === 'PENDING'">Sending...</div>
                        </div>
                    </div>
                </div>

                <vue-recaptcha :sitekey="recapthcakey"
                               data-badge="inline"
                               ref="recaptcha"
                               size="invisible"
                               @verify="onVerify"></vue-recaptcha>
            </div>
        </form>
    </div>
</template>

<script>
    import fieldsvacancy from "./fieldsvacancy.vue";
    import Vue from 'vue'
    import Vuelidate from 'vuelidate'
    import { required, email } from 'vuelidate/lib/validators'
    import VueRecaptcha from 'vue-recaptcha';
    import VueScrollTo from 'vue-scrollto'
    import VueMask from 'v-mask'

    Vue.use(VueMask);
    Vue.use(Vuelidate);
    Vue.use(VueScrollTo);

    export default {
        name: 'Contact',
        components: {
            'vue-recaptcha': VueRecaptcha,
            fieldsvacancy
        },
        props: [
            'recapthcakey',
            'form',
            'actionprops',
            'career',
            'form_id'
        ],
        data() {
            return {
                captcha: '',
                childIsValid: false,
                fileName: '',
                file: [],
            }
        },
        validations() {

        },
        methods: {
            onFileChange(el) {
                // eslint-disable-next-line no-unused-vars
                const files = el.target.files || el.dataTransfer.files
                // eslint-disable-next-line prefer-destructuring
                this.fileName = document.getElementById('upload').files[0].name
                this.file.push(document.getElementById('upload').files[0])
            },
            submit() {
                this.$eventPool.$emit("touchChildForm")

                this.$nextTick(() => {
                    if (this.childIsValid) {
                        this.$refs.recaptcha.execute();
                    } else {
                        this.$store.state.submitStatus = 'ERROR';
                        VueScrollTo.scrollTo('.error', 300, {container: '#wrapper',});
                    }
                })
            },
            onVerify: function (response) {
                this.$store.state.submitStatus = 'PENDING';

                let formData = new FormData();
                formData.append('g-recaptcha-response', response)
                formData.append('form_type', 'apply-for-a-job')
                formData.append('career', '#' + this.career.id + ' - ' + this.career.title)
                formData.append('form_id', this.form_id)

                if (this.file[0]) {
                    formData.append('file', this.file[0]);
                }

                const currentForm = this.$store.state.currentForm
                Object.keys(currentForm).forEach((item) => {
                    if (typeof currentForm[item] === 'object') {
                        formData.append(item, JSON.stringify(currentForm[item]))
                    } else {
                        formData.append(item, currentForm[item])
                    }
                })

                axios.post(this.actionprops, formData)
                    .then(response => {
                        console.log('message', response);

                        if (response.data.result === 'ok') {
                            this.$store.state.submitStatus = 'OK';

                            formData = new FormData();
                            this.childHasError = true;
                            this.$store.state.currentForm = {};
                            this.$refs.vform.reset();
                            this.$eventPool.$emit("resetChildForm");
                        }

                        if (response.data.result === 'error') {
                            this.$store.state.submitStatus = 'ERROR';
                        }

                        this.$refs.recaptcha.reset();
                    })
                    .catch(error => {
                        console.log(error)
                        this.$refs.recaptcha.reset();
                    });
            },
            status(validation) {
                return {
                    error: validation.$error,
                    dirty: validation.$dirty
                }
            },
            closeModaljoin() {
                this.$store.state.joinModalAtive = false
                this.$store.state.noscrollActive = false
            },
        },
    }
</script>

<style scoped lang="scss">
    .form .info-text {
        margin-top: 0;
    }

</style>
